import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { additionalValue } from '@/react-query/context/ApiClientContextController';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { hostListQueries } from '@/services/hostManagement/hostManagement.queries';
import { useParams, useSearch } from '@tanstack/react-router';

export const useHostList = () => {
  const search = useSearch({ from: '/(app)/store-information/premium-stores/host-management/$clubid/' });
  const clubId = useParams({ from: '/(app)/store-information/premium-stores/host-management/$clubid/' });

  const { createdDate, page, fetch } = search;

  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });

  const { data, isLoading } = useQuery({
    ...hostListQueries.list({
      clubId: clubId['clubid'],
      fromDate: parsedCreatedDate?.start,
      toDate: parsedCreatedDate?.end,
      row: page,
      fetch: fetch,
      search: search.q,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data ?? [], search.sort),
    }),
    enabled: !!clubId.clubid,
  });
  return {
    getHostList: data?.data || [],
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
    additionalValue: (data?.meta?.additionalValue || '') as additionalValue,
  };
};
